import qs from 'query-string';

export const langs = ['en', 'sv'];

// Resolve the active UI language from a location.search string.
// Order: top-level `lang`, then a `lang` nested in the `next` redirect
// param (e.g. ?next=%2Fprofile%3Flang%3Den), then `fallback` (typically the
// stored user language), then default 'sv'.
export const resolveLangFromSearch = (search, fallback) => {
  const params = qs.parse(search);
  let { lang } = params;

  // query-string turns a duplicated `next` into an array; only parse a string.
  if (!langs.includes(lang) && typeof params.next === 'string') {
    const [, nextQuery] = params.next.split('?');

    if (nextQuery) {
      ({ lang } = qs.parse(nextQuery));
    }
  }

  if (!langs.includes(lang)) {
    lang = fallback;
  }

  return langs.includes(lang) ? lang : 'sv';
};

// Path to the customer-facing main site for a given UI language.
// sv -> '/', otherwise '/en' (the frontend maps /en to en-gb).
export const mainSiteHref = (lang) => (lang === 'sv' ? '/' : '/en');
